export default __webpack_public_path__ + "static/media/avatar_placeholder_1.9026ae3f.jpg";